import { j as d } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as f } from "../../../node_modules/clsx/dist/clsx.m.js";
import { memo as x } from "react";
import o from "./Containers.module.scss.js";
const u = ({
  className: r = "",
  children: s,
  color: t = "primary-dark",
  borderRadius: a = "none",
  border: e = !1,
  zIndex: n = 0,
  styles: m,
  height: i = "auto",
  width: c = "auto",
  ...l
}) => {
  const p = f(
    o.containers,
    o[t],
    o[a],
    o[`zIndex-${n}`],
    r
  );
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      className: p,
      style: { ...m, width: c, height: i },
      "data-border": e,
      ...l,
      children: s
    }
  );
}, b = x(u);
export {
  b as default
};
//# sourceMappingURL=Containers.js.map
